import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../data/products';
import { useCartStore } from '../store/cart';
import { toast } from 'sonner';
interface ProductCardProps {
  product: Product;
}
const getColorHex = (colorName: string) => {
  const map: Record<string, string> = {
    Black: '#171717',
    White: '#f5f5f5',
    'Washed Grey': '#525252',
    'Black/Gold': '#262626',
    'Navy/White': '#1e3a8a',
    Olive: '#4d7c0f',
    Cream: '#fef3c7',
    Charcoal: '#3f3f46',
    Burgundy: '#881337',
    'Forest Green': '#14532d',
    Stone: '#d6d3d1',
    Tan: '#d2b48c',
    'Slate Blue': '#475569',
    'Heather Grey': '#9ca3af'
  };
  return map[colorName] || '#000000';
};
export function ProductCard({
  product
}: ProductCardProps) {
  const [selectedColor, setSelectedColor] = useState<string>(product.colorways[0]);
  const [selectedSize, setSelectedSize] = useState<string>('');
  const addItem = useCartStore(state => state.addItem);
  const handleAction = (e: React.MouseEvent) => {
    e.preventDefault();
  };
  const handleAddToCart = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!selectedSize) {
      toast.error('Please select a size first');
      return;
    }
    addItem(product, selectedColor, selectedSize);
    toast.success(`Added ${product.name} to cart`);
  };
  return <Link to={`/product/${product.id}`} className="group block bg-neutral-900/40 rounded-sm p-4 transition-transform duration-300 hover:-translate-y-1 border border-neutral-800/50 hover:border-neutral-700" data-id="element-87">
      <div className="aspect-square bg-neutral-800 mb-4 overflow-hidden rounded-sm" data-id="element-88">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity duration-300" data-id="element-89" />
      </div>

      <div className="flex justify-between items-start gap-4" data-id="element-90">
        <h3 className="font-sans font-medium text-lg text-white relative inline-block pb-1" data-id="element-91">
          {product.name}
          <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-vsc-gold transition-all duration-300 group-hover:w-full" data-id="element-92"></span>
        </h3>
        <p className="text-neutral-300 font-medium whitespace-nowrap" data-id="element-93">
          ${product.price}
        </p>
      </div>

      <div className="mt-4 space-y-4" data-id="element-94">
        {/* Colorways */}
        <div className="flex gap-2" onClick={handleAction} data-id="element-95">
          {product.colorways.map(color => <button key={color} onClick={() => setSelectedColor(color)} className={`w-4 h-4 rounded-full border transition-transform ${selectedColor === color ? 'border-vsc-gold scale-125' : 'border-neutral-600 hover:scale-110'}`} title={color} style={{
          backgroundColor: getColorHex(color)
        }} aria-label={`Select ${color}`} data-id="element-96" />)}
        </div>

        {/* Sizes */}
        <div className="flex flex-wrap gap-2" onClick={handleAction} data-id="element-97">
          {product.sizes.map(size => <button key={size} onClick={() => setSelectedSize(size)} className={`text-xs border px-2 py-1 transition-colors ${selectedSize === size ? 'border-vsc-gold text-vsc-gold' : 'border-neutral-700 text-neutral-400 hover:text-white hover:border-neutral-500'}`} data-id="element-98">
              {size}
            </button>)}
        </div>
      </div>

      <button onClick={handleAddToCart} className="w-full mt-6 bg-white text-black font-medium py-2.5 hover:bg-vsc-gold transition-colors rounded-sm" data-id="element-99">
        Add to Cart
      </button>
    </Link>;
}